import { findIndex } from 'lodash'
import { CourseType, LessonType } from '../../../types'
import { getCourseLessons } from '.'

export const getLessonIndex = (lesson?: LessonType, course?: CourseType) => {
  if (!lesson || !course) {
    return 0
  }

  const allLessons = getCourseLessons(course)
  return findIndex(allLessons, (l) => l._id === lesson._id)
}
